import { SearchField, Stack } from '@eleveo/components-react';
import { FormApi } from 'final-form';
import React from 'react';
import { Form, FormRenderProps, useFormState } from 'react-final-form';
import { useTranslation } from 'react-i18next';

import { SEARCH_AGENTS_CONTAINER_TAG } from './constants';
import { useDebouncedField } from '../../utils/useDebounceField';
import { max255chars } from '../../utils/validations';

interface AgentsHeaderFilter {
  name: string;
  surname: string;
}

export type AgentsHeaderFilterType = Partial<AgentsHeaderFilter>;

interface AgentsHeaderSearchFormProps {
  onSubmit: (values: AgentsHeaderFilterType, formProps: FormApi<AgentsHeaderFilterType>) => void;
}

const AgentsHeaderSearchFormInner: React.FC<FormRenderProps<AgentsHeaderFilterType>> = ({ handleSubmit }) => {
  const { t } = useTranslation();

  useFormState<AgentsHeaderFilterType>({
    subscription: { dirty: true, modified: true, values: true },
    onChange: ({ modified }) => {
      // Do not fire on initial render, when updating state is causing React error
      if (modified?.name || modified?.surname) {
        handleSubmit();
      }
    },
  });

  const { input: nameInput } = useDebouncedField('name', { validate: max255chars });
  const { input: surnameInput } = useDebouncedField('surname', { validate: max255chars });

  return (
    <form>
      <Stack direction="horizontal" testId={SEARCH_AGENTS_CONTAINER_TAG}>
        {/* TODO: At final state, single <SearchField /> component should be used to provide full-search behavior upon any field within table */}
        <SearchField
          placeholder={t('person.firstName')}
          testId="list-filter:input-search--name"
          {...nameInput}
          className="agents-header-search-form__search"
        />

        <SearchField
          placeholder={t('person.lastName')}
          testId="list-filter:input-search--surname"
          {...surnameInput}
          className="agents-header-search-form__search"
        />
      </Stack>
    </form>
  );
};

export const AgentsHeaderSearchForm: React.FC<AgentsHeaderSearchFormProps> = ({ onSubmit }) => (
  <Form<AgentsHeaderFilterType> onSubmit={onSubmit} data-test-id="agents-header-search-form">
    {(renderProps) => <AgentsHeaderSearchFormInner {...renderProps} />}
  </Form>
);
